import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DefaultExcelExport from '../../subcomponents/DefaultExcelExport';
import { GetDate, GetTime } from '../../../app/AppUtils';

export default function ExportExcelIdealTransactions({ disabled, jsonData }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const [excelDataRows, setExcelDataRows] = useState([]);
    const [excelHeaderRow, setExcelHeaderRow] = useState([]);
    const [excelFileName, setExcelFileName] = useState("");

    useEffect(() => {
        if (jsonData) {
            // Header row
            setExcelHeaderRow([
                resourceFinal[appLanguage].words.TRANSACTION,
                resourceFinal[appLanguage].words.STATUS,
                `${resourceFinal[appLanguage].words.TRANSACTION}${resourceFinal[appLanguage].words.AMOUNT.toLowerCase()}`,
                resourceFinal[appLanguage].words.STATUS,
                resourceFinal[appLanguage].words.NAME_FIRST,
                resourceFinal[appLanguage].words.NAME_INSERTION,
                resourceFinal[appLanguage].words.NAME_LAST,
                resourceFinal[appLanguage].words.ACTIVITY,
                resourceFinal[appLanguage].words.PERFORMANCE,
                `${resourceFinal[appLanguage].words.PERFORMANCE}${resourceFinal[appLanguage].words.NUMBER.toLowerCase()}`,
                resourceFinal[appLanguage].words.UNSUBSCRIBED_DATE,
                resourceFinal[appLanguage].words.UNSUBSCRIBED_BY,
                resourceFinal[appLanguage].words.DATE_CREATED,
                resourceFinal[appLanguage].words.CREATED_BY,
                resourceFinal[appLanguage].words.DATE_MODIFIED,
                resourceFinal[appLanguage].words.MODIFIED_BY,
            ]);

            // Data rows
            let dataRows = [];

            jsonData?.forEach(item => {
                dataRows.push(
                    Object.keys(item).map(key => {
                        const value = item[key];

                        if (key.toLowerCase().includes("date") || key.toLowerCase().includes("time")) {
                            return value === null ? "" : `${GetDate(value)} (${GetTime(value)})`;
                        }

                        return value === null ? "" : value;
                    })
                );
            });

            setExcelDataRows(dataRows);

            // File name
            setExcelFileName(`${resourceFinal[appLanguage].words.REPORT_TRANSACTIONS} - ${jsonData[0]?.activityName}`);
        }
    }, [jsonData]);

    return (
        <DefaultExcelExport
            headerRow={excelHeaderRow}
            dataRows={excelDataRows}
            fileName={excelFileName}
            buttonText={`${resourceFinal[appLanguage].words.EXPORT} ${resourceFinal[appLanguage].words.EXCEL.toLowerCase()}`}
            disabledCondition={disabled}
        />
    );
}
